import { apiService } from './api';

// 🔴 LE SERVICE NE DÉBALLE PLUS, ET IL PASSE LES PARAMÈTRES — lot RU7-a.
// Il rendait `response.data.notifications`, c'est-à-dire **la page**, en jetant
// `total`, `pages` et les compteurs. La route pagine pourtant DEPUIS TOUJOURS,
// avec `per_page` à 20 par défaut. Conséquences mesurées :
//   · au-delà de 20 notifications, l'écran en perdait silencieusement — pas de
//     pied de tableau, pas de page suivante, aucun signe ;
//   · ses quatre cartes de statistiques comptaient la PAGE en se présentant
//     comme des totaux — *un chiffre juste sur son sous-ensemble et faux comme
//     total*, le défaut exact de la Comptabilité avant RU4-d ;
//   · et ses filtres `type` / `is_read` étaient refaits en JavaScript alors que
//     la route les sert, donc ils ne filtraient que les 20 chargées.
// ⚠️ LA BASE DE DÉVELOPPEMENT EN PORTE **6** : le décor cachait tout cela, et
// l'aurait caché jusqu'à la vingt et unième.
export const getNotifications = async (params = {}) => {
  const response = await apiService.get('/notifications', params);
  return response.data;
};

// Récupérer une notification par ID
export const getNotification = async (id) => {
  const response = await apiService.get(`/notifications/${id}`);
  return response.data;
};

// Marquer une notification comme lue
export const markNotificationAsRead = async (id) => {
  const response = await apiService.put(`/notifications/${id}/read`);
  return response.data;
};

// Marquer une notification comme non lue
export const markNotificationAsUnread = async (id) => {
  const response = await apiService.put(`/notifications/${id}/unread`);
  return response.data;
};

// Marquer toutes les notifications comme lues
export const markAllAsRead = async () => {
  const response = await apiService.put('/notifications/read-all');
  return response.data;
};

// Supprimer une notification
export const deleteNotification = async (id) => {
  const response = await apiService.delete(`/notifications/${id}`);
  return response.data;
};

// Obtenir le nombre de notifications non lues
export const getUnreadNotificationsCount = async () => {
  const response = await apiService.get('/notifications/unread-count');
  return response.data.unread_count;
};

// Obtenir le résumé des notifications
// 🔴 QUATRE MÉTHODES RETIRÉES AU LOT RU7-a, avec les quatre routes qu'elles
// appelaient : `getNotificationsSummary`, `getNotificationTypes`,
// `getLowStockNotifications` et `clearOldNotifications`. **Zéro appelant** —
// mesuré par énumération sur tout le front.
// ⚠️ Elles ne mentaient pas comme les deux routes fantômes de RU6 : elles
// EXISTAIENT des deux côtés. Du code entretenu, testé, corrigé au chantier IDOR,
// que personne n'appelait. *Le code mort qui fonctionne est le plus difficile à
// retirer : rien en lui ne signale qu'il est mort.*
